import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import config from '@/config';
import { getPlatformCode } from '@/features/game/platform-helpers';
import { SessionContext } from '@/features/game/types';
import { getProduct } from '@/features/game-context/platform-helpers';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { Product } from '@/features/game-context/types';

export const useSessionContext = (): SessionContext | undefined => {
  const ctx = useSelector(gameContextSelector);

  const sessionCode = useMemo(() => {
    const { brandCode } = config.cpp;
    const platformCode = getPlatformCode();

    return `AA${brandCode}${platformCode}`;
  }, []);

  const sessionContext: SessionContext | undefined = useMemo(
    () =>
      ctx.brand && ctx.region
        ? {
            fdBrand: ctx.brand,
            fdProduct: getProduct() as Product,
            fdSessionCode: sessionCode,
            fdState: ctx.region,
            fdVersion: '8.0.0',
            session_code: sessionCode,
          }
        : undefined,
    [ctx.brand, ctx.region, sessionCode],
  );

  return sessionContext;
};
